import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import FormHeader from 'components/global/FormHeader';
import { HeaderContainerFormHeader } from 'components/global/styled/FormHeader.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, WMS_MODULE } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';
import PATHS, { mergePaths } from 'utils/paths';

import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';

const InventoryTransactions = () => {
	const location = useLocation();

	const defaultSort = useMemo(() => [{ id: 'id', desc: true }], []);

	const columns = useMemo(
		() => [
			{ Header: 'id', accessor: 'id', filterType: FilterType.number, show: false },
			{
				Header: 'orderID',
				accessor: 'orderNumber',
				filterType: FilterType.string,
				width: 30
			},
			{
				Header: 'action',
				accessor: 'action',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.INV_TRANSACTIONS_ACTION,
				width: 20
			},
			{
				Header: 'date',
				accessor: 'date',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME,
				width: 50
			},
			{
				Header: 'type',
				accessor: 'type',
				filterType: FilterType.multiSelection,
				width: 20
			},
			{
				Header: 'warehouseName',
				accessor: 'warehouseName',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.WAREHOUSES,
				width: 30
			},
			{
				Header: 'branch',
				accessor: 'branchName',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.BRANCHES,
				width: 30
			},

			{
				Header: 'description',
				accessor: 'description',
				filterType: FilterType.string
			},
			{
				Header: 'sku',
				accessor: 'sku',
				filterType: FilterType.string,
				width: 30
			},
			{
				Header: 'quantity',
				accessor: 'quantity',
				filterType: FilterType.float,
				width: 25
			},
			{
				Header: 'newQuantity',
				accessor: 'newQuantity',
				filterType: FilterType.float,
				width: 25
			},
			{
				Header: 'prevQuantity',
				accessor: 'prevQuantity',
				filterType: FilterType.float,
				width: 25
			},
			{
				Header: 'pickupLocationCode',
				accessor: 'pickupLocationCode',
				filterType: FilterType.multiSelection,
				width: 30
			}
		],
		[]
	);

	return (
		<div>
			<HeaderContainerFormHeader>
				<FormHeader
					lightTitle="reports"
					boldTitle="inventoryTransactions"
					icon={faArrowLeft}
					backUrl={mergePaths(PATHS.REPORTS, PATHS.OTO_PACK_REPORTS)}
				/>
			</HeaderContainerFormHeader>

			<DynamicList
				id={DYNAMICLISTS.INVENTORY_TRANSACTIONS}
				defaultSort={defaultSort}
				columns={columns}
				fetchUrl={WMS_MODULE.GET_INVENTORY_TRANSACTIONS_LIST}
				exportName="inventoryTransactions"
				actionObjectType={ACTION_OBJECT_TYPES.WMS}
				infiniteScroll
				defaultFilters={location?.state?.defaultFilters?.map(({ column, action, value }) => ({
					column: columns.find((c) => c.accessor === column.accessor),
					action,
					value
				}))}
			/>
		</div>
	);
};

export default InventoryTransactions;
